import { BaseAppService } from "src/app/services/configurators-2d/base-app-service";
import { Configuration2D } from "./configuration2d";

export class CommonOrder {
  public service: BaseAppService<Configuration2D>;
  public id: string;
  public checkInstallation: boolean;
  public checkOrder: boolean;

  constructor(service: any, id: string) {
    this.service = service;
    this.id = id;
    this.checkInstallation = true;
    this.checkOrder = true;
  }
}
